<div class="server-error-cont animated fadeIn">
  <div class="message-cont">
    <img class="app-logo animated zoomIn" alt="pet-up-leadership" src="../../../assets/svg/pet-up-leadership.svg" />
    <h3 class="main-msg animated zoomIn" *ngIf="errMsg != ''">{{ errMsg }}</h3>
    <h5 class="msg-desc animated zoomIn" *ngIf="errSubMsg != ''">{{ errSubMsg }}</h5>
    <button class="refresh-btn animated zoomIn" (click)="refreshApp()" *ngIf="showRefresh">
      <mat-icon class="text-white">refresh</mat-icon> Try again
    </button>
    <button class="refresh-btn animated zoomIn" (click)="logout()" *ngIf="showLogout">
      <mat-icon
        aria-hidden="false"
        aria-label="logout icon"
        fontIcon="logout"
        [ariaSetSize]="50"
        color="text-white"
      ></mat-icon>
      Logout
    </button>
  </div>
</div>
